import { render, staticRenderFns } from "./swiperModal.vue?vue&type=template&id=112b7b76&"
import script from "./swiperModal.vue?vue&type=script&lang=js&"
export * from "./swiperModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports